module.exports = __webpack_public_path__ + "img/ditu.b9c83b05.png";